import React, { Component } from 'react';
import { connect } from 'react-redux';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Popup } from 'semantic-ui-react';
import { TableForm, LoadingBar, Pagination } from '../Commons';
import DetailSikdaeResultModal from './Modal/DetailSikdaeResultModal';
import { getSettlementHeaderIndex } from './utils';

class DetailSikdaeResult extends Component {
  render() {
    const { detailList, modalFn } = this.props;
    const {
      resultFn: { pageClick, openModal }
    } = this.props;

    let page = 1;
    let pagerow = 0;
    let totalcount = 0;

    const header = [
      { data: '결제번호', textAlign: 'left' },
      { data: '날짜', textAlign: 'left' },
      { data: 'ID', textAlign: 'left' },
      { data: '이름', textAlign: 'left' },
      { data: '사번', textAlign: 'left' },
      { data: '가맹점', textAlign: 'left' },
      { data: '사용 포인트', textAlign: 'right' },
      { data: '정산 금액', textAlign: 'right' },
      { data: '결제 형태' }
    ];

    // tableHeaderList 가 pDepth 없이 isPast=true 로 쓰는 값과 같은 소스여야 부서 컬럼 수와 어긋나지 않는다
    const depth = storage.get('pastDepth') || 0;
    let main = cm.tableHeaderList(header, 5, false, 'default', null, true);
    const settlementIndex = getSettlementHeaderIndex(depth);
    // 아이콘(JSX)은 tableHeaderList 의 JSON 깊은 복사를 통과하지 못하므로 splice 뒤에 넣는다
    // hoverable 이 없으면 툴팁이 아이콘을 덮는 순간 trigger 의 mouseleave 로 닫혔다 다시 열려 깜박인다
    main[settlementIndex - 1] = {
      data: '사용 포인트',
      textAlign: 'right',
      isTooltip: true,
      icon: <InfoCircleOutlined />,
      content: '조회된 정책에서 사용한 포인트의 합계가 표시됩니다.',
      tooltipProps: { hoverable: true }
    };
    main[settlementIndex] = {
      data: '정산 금액',
      textAlign: 'right',
      isTooltip: true,
      icon: <InfoCircleOutlined />,
      content: (
        <span>
          정산금액은 사용 포인트에 대한 정산 예정 금액입니다.
          <br />
          함께결제 시 방장의 결제 내역에만 금액이 표시됩니다.
        </span>
      ),
      tooltipProps: { hoverable: true }
    };

    const tabledata = {
      header: {
        main
      },
      body: {
        message: '식대 상세조회 내역이 존재하지 않습니다.',
        main: null
      }
    };

    let loading = '';
    if (detailList) {
      if (detailList.data) {
        const { paging, room } = detailList.data;

        if (paging) {
          page = paging.page;
          pagerow = paging.pagerow;
          totalcount = paging.totalcount;
        }

        if (room && room.length > 0) {
          tabledata.body.main = room.map((item) => {
            const { user, point, pay } = item;

            let signId = '-';
            if (user) {
              signId = user.signid ? user.signid : '-';
            }

            let pointCom = '-';
            if (point && point.com) {
              pointCom = cm.numberComma(item.point.com);
            }

            let payAmount = '-';
            let payText = '-';
            let payType = false;
            if (pay) {
              if (pay.amount) {
                payAmount = cm.numberComma(item.pay.amount);
              }
              if (pay.text) {
                payText = item.pay.text;
              }
              if (pay.type === 1) {
                payType = true;
              }
            }

            let obj = {
              row: [
                {
                  data: payType ? item.id : '',
                  textAlign: 'left'
                },
                {
                  data: `${cm.yyyyMMdd(new Date(item.usedate))} ${cm.hhmmss(new Date(item.usedate))}`,
                  textAlign: 'left'
                },
                {
                  data: signId,
                  textAlign: 'left'
                },
                {
                  data: item.user.name,
                  textAlign: 'left'
                },
                {
                  data: item.user.comidnum,
                  textAlign: 'left'
                },
                {
                  data: item.store.name,
                  textAlign: 'left'
                },
                {
                  data: pointCom,
                  textAlign: 'right'
                },
                {
                  data: payType ? payAmount : '',
                  textAlign: 'right'
                },
                {
                  data: payText
                }
              ]
            };

            obj = cm.defalutTableStaffDivisionSet(obj.row, 5, item.user.orgCode, null, null, true);
            obj.clickFunc = openModal;
            obj.clickData = item.couponid;

            return obj;
          });
        }
      } else if (detailList.response) {
        tabledata.body.message = detailList.response.data.message;
      }
    } else {
      // loading = <LoadingBar />;
    }

    return (
      <div className="ds-result">
        {loading}

        <div className="table-box">
          <TableForm tabledata={tabledata} selectable="true" />
        </div>

        <div className="table-paging">
          <Pagination page={page} pageRow={pagerow} pageBlock={10} totalCount={totalcount} pageClick={pageClick} />
        </div>

        <DetailSikdaeResultModal modalFn={modalFn} />
      </div>
    );
  }
}

export default connect((state) => ({
  detailList: state.usage.detailList
}))(DetailSikdaeResult);
